import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import styles from "./contactUs.module.scss";
import useTranslation from "next-translate/useTranslation";
import { handleChange, submitMessage } from "./services";

var Index = function Index() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var _useState = useState({
    Name: "",
    TelNum: "",
    EmailAdd: "",
    Msg: ""
  }),
      input = _useState[0],
      setInput = _useState[1];

  var _useState2 = useState(),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(),
      serverResponse = _useState3[0],
      setServerResponse = _useState3[1];

  var _useState4 = useState({
    "id": 13,
    "quantity": 200,
    "offer": {
      "id": 459,
      "createdById": 59,
      "updatedById": null,
      "createdAt": "2022-01-18T08:32:58.945Z",
      "updatedAt": "2022-01-18T09:29:04.325Z",
      "deletedAt": null,
      "productName": "test",
      "unitId": 2,
      "minQuantity": 100,
      "description": "test",
      "productId": null,
      "warehouseId": 2,
      "productCategoryId": 1,
      "sellerId": 572,
      "oldPrice": 500,
      "price": 200,
      "phoneNumber": "09363552844",
      "maxQuantity": 1500,
      "remainingQuantity": 1500,
      "showOffer": true,
      "specialExpireAt": null,
      "onlineReserveExpireAt": "2021-01-18T08:20:48.172Z",
      "isSpecial": false,
      "isOnlineReserveExpired": true
    },
    "pricePerUnit": 200,
    "totalPrice": 40000,
    "createdAt": "2022-01-19T10:43:18.490Z",
    "updatedAt": "2022-01-19T10:43:20.054Z"
  }),
      test = _useState4[0],
      setTest = _useState4[1];

  useEffect(function () {
    setTimeout(function () {
      setTest(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          quantity: 300
        });
      });
    }, 1000);
  }, []);
  console.log('test', test);
  useEffect(function () {
    var token = localStorage.getItem('token');
    var Username = localStorage.getItem('Username');

    if (token && Username) {
      setInput(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          Name: Username
        });
      });
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx("h1", {
        className: styles.pageTitle,
        children: t('contactUs:contact')
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.flexContainer,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.leftOrTop,
          children: [serverResponse && /*#__PURE__*/_jsx("label", {
            className: styles.rtl,
            children: isRTL ? serverResponse.messageFa : serverResponse.message
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.Name ? isRTL ? error.NameFa : error.Name : ""
          }), /*#__PURE__*/_jsx("input", {
            className: "".concat(styles.form, " form-control  ").concat(error && error.Name ? styles.isInvalid : "is-valid"),
            placeholder: t("contactUs:name"),
            onChange: function onChange(e) {
              return handleChange(setError, setInput, e);
            },
            value: "".concat(input.Name),
            name: "Name",
            id: isRTL ? "user-icon-contactUsFa" : "user-icon-contactUs"
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.TelNum ? isRTL ? error.TelNumFa : error.TelNum : ""
          }), /*#__PURE__*/_jsx("input", {
            className: "".concat(styles.form, " form-control ").concat(error && error.TelNum ? styles.isInvalid : "is-valid"),
            placeholder: t('contactUs:phone-number'),
            onChange: function onChange(e) {
              return handleChange(setError, setInput, e);
            },
            value: input.TelNum,
            name: "TelNum",
            id: isRTL ? "mobile-icon-contactUsFa" : "mobile-icon-contactUs",
            style: {
              fontFamily: isRTL ? "Yekan" : "Helvetica"
            }
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.EmailAdd ? isRTL ? error.EmailAddFa : error.EmailAdd : ""
          }), /*#__PURE__*/_jsx("input", {
            className: "".concat(styles.form, " form-control  ").concat(error && error.EmailAdd ? styles.isInvalid : "is-valid"),
            placeholder: t('contactUs:email-address'),
            onChange: function onChange(e) {
              return handleChange(setError, setInput, e);
            },
            value: input.EmailAdd,
            name: "EmailAdd",
            id: isRTL ? "email-icon-contactUsFa" : "email-icon-contactUs"
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.Msg ? isRTL ? error.MsgFa : error.Msg : ""
          }), /*#__PURE__*/_jsx("textarea", {
            className: "".concat(styles.textArea, " form-control  ").concat(error && error.Msg ? styles.isInvalid : "is-valid"),
            placeholder: t('contactUs:message'),
            onChange: function onChange(e) {
              return handleChange(setError, setInput, e);
            },
            value: input.Msg,
            name: "Msg",
            id: isRTL ? "message-icon-contactUsFa" : "message-icon-contactUs"
          }), /*#__PURE__*/_jsx("button", {
            onClick: function onClick(e) {
              return submitMessage(e, input, setInput, setError, setServerResponse);
            },
            className: "".concat(styles.submitButton, " ").concat(styles.showOnSmallScreen),
            children: t('contactUs:send-message')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.rightOrBottom,
          children: [/*#__PURE__*/_jsxs("div", {
            className: isRTL ? styles.logosFa : styles.logosEng,
            children: [/*#__PURE__*/_jsx("img", {
              className: styles.kanoonLogo,
              src: "/images/contactUs/kanoon-logo.svg",
              alt: ""
            }), /*#__PURE__*/_jsx("img", {
              className: styles.wowLogo,
              src: "/images/contactUs/wow-logo.svg",
              alt: ""
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: isRTL ? styles.infoFa : styles.infoEng,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.eng_info_title,
              children: t('contactUs:general-inquiries')
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.english,
              children: [/*#__PURE__*/_jsx("p", {
                className: "".concat(styles.englishAddress, " ").concat(styles.ml),
                children: "Address: Kanoon Farhangi Amoozesh, Enghelab Street,"
              }), /*#__PURE__*/_jsxs("div", {
                className: "d-flex justify-content-center ",
                children: [/*#__PURE__*/_jsx("p", {
                  className: styles.englishAddress2,
                  children: "Tehran, Iran"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.englishPhone,
                  children: "Phone: 0216463"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.englishFax,
                  children: "Fax: 0216463"
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.internetAddresses,
              children: [/*#__PURE__*/_jsx("p", {
                className: "".concat(styles.emailAddress, " ").concat(isRTL ? styles.mr : styles.ml),
                children: "EmailAdd: en@kanoon.ir"
              }), /*#__PURE__*/_jsx("div", {
                className: styles.socialLinks,
                children: /*#__PURE__*/_jsx("a", {
                  className: styles.instagram,
                  target: "_blank",
                  href: "https://www.instagram.com/wow.kanoon.ir/",
                  children: /*#__PURE__*/_jsx("img", {
                    className: "".concat(styles.instagram, " ").concat(isRTL ? styles.ml : styles.mr),
                    src: "/images/contactUs/instagram-logo.svg",
                    alt: ""
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.farsi,
              children: [/*#__PURE__*/_jsx("p", {
                className: "".concat(styles.farsiAddress, " ").concat(isRTL ? styles.mr : ''),
                children: "\u062F\u0641\u062A\u0631 \u0645\u0631\u06A9\u0632\u06CC: \u062A\u0647\u0631\u0627\u0646 - \u062E\u06CC\u0627\u0628\u0627\u0646 \u0627\u0646\u0642\u0644\u0627\u0628 - \u0628\u06CC\u0646 \u0641\u0644\u0633\u0637\u06CC\u0646 \u0648 \u0635\u0628\u0627 -"
              }), /*#__PURE__*/_jsxs("div", {
                className: "d-flex justify-content-center ",
                children: [/*#__PURE__*/_jsx("p", {
                  className: styles.farsiAddress2,
                  children: "\u067E\u0644\u0627\u06A9 \u06F9\u06F2\u06F3"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.farsiPhone,
                  children: "\u062A\u0644\u0641\u0646: \u06F0\u06F2\u06F1\u06F6\u06F4\u06F6\u06F3"
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.farsiFax,
                  children: "\u0641\u0627\u06A9\u0633: \u06F0\u06F2\u06F1\u06F6\u06F4\u06F6\u06F3"
                })]
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("button", {
        onClick: function onClick(e) {
          return submitMessage(e, input, setInput, setError, setServerResponse);
        },
        className: "".concat(styles.submitButton, " ").concat(styles.showOnLargeScreen),
        children: t('contactUs:send-message')
      })]
    })
  });
};

export default Index;